import {
  getAllUserNotifications,
  markAsReadNotification,
} from "../../../Redux/Notifications/NotificationsActions";
import NotificationDetailModal, {
  UserNotification,
} from "../NotificationDetailModal/NotificationDetailModal";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import { logoutUser } from "../../../Redux/Auth/AuthActions";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../Redux/store";
import { RootState } from "../../../Redux/store";
import Logo from "../../../Assets/Logo.png";
import { useEffect, useState } from "react";
import { FaRegBell } from "react-icons/fa";
import styles from "./Header.module.scss";
import { Link } from "react-router";

function Header() {
  const { user, token } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch<AppDispatch>();
  const { userNotifications } = useSelector(
    (state: RootState) => state.notifications,
  );
  const [isNotificationModalOpen, setIsNotificationModalOpen] = useState(false);
  const [selectedNotification, setSelectedNotification] =
    useState<UserNotification | null>(null);

  const filteredUserNotifications = userNotifications?.filter(
    (notification: UserNotification) => notification?.messageSent,
  );

  const notificationClickHandler = (notification: UserNotification) => {
    setSelectedNotification(notification);
    setIsNotificationModalOpen(true);

    if (!notification?.seenByMember) {
      const successHandler = () => {
        dispatch(getAllUserNotifications());
      };
      dispatch(
        markAsReadNotification({
          notificationId: notification.notificationId,
          successHandler,
        }),
      );
    }
  };

  const unseeNotificationsCount =
    userNotifications?.filter(
      (notification: UserNotification) => !notification?.seenByMember,
    )?.length ?? 0;

  useEffect(() => {
    if (!user || !token) return;

    dispatch(getAllUserNotifications());

    const intervalId = setInterval(() => {
      dispatch(getAllUserNotifications());
    }, 30000);

    return () => clearInterval(intervalId);
  }, [dispatch, user, token]);

  return (
    <div className={styles.mainContainer}>
      <Link to="/" className={styles.logoContainer}>
        <img src={Logo} alt="logo" className={styles.logo} />
      </Link>
      {!user && !token && (
        <div className={styles.menuContainer}>
          <a href="mailto:info@amenigies.com">
            <button className={styles.loginButton}>Contact US</button>
          </a>
          <Link className={styles.loginButton} to="/login" replace>
            Login
          </Link>
        </div>
      )}
      {user && token && (
        <div className={styles.menuContainer}>
          <Menu
            className={styles.notificationMenu}
            direction="left"
            menuButton={
              <MenuButton>
                <div className={styles.notificationContainer}>
                  <FaRegBell className={styles.icon} />
                  {unseeNotificationsCount > 0 && (
                    <p className={styles.NotificationsCount}>
                      {unseeNotificationsCount}
                    </p>
                  )}
                </div>
              </MenuButton>
            }
            transition
          >
            {filteredUserNotifications?.length === 0 && (
              <div className={styles.noNotificationsContainer}>
                <p className={styles.noNotificationsText}>No notifications</p>
              </div>
            )}
            {filteredUserNotifications?.map(
              (notification: UserNotification, i) => (
                <MenuItem
                  key={notification?.notificationId ?? i}
                  onClick={() => notificationClickHandler(notification)}
                >
                  <div
                    className={
                      notification?.seenByMember
                        ? styles.notificationItem
                        : styles.unreadNotificationItem
                    }
                  >
                    <div className={styles.unreadNotificationText}>
                      <p className={styles.title}> {notification?.title}</p>
                      <span className={styles.unreadCircle}></span>
                    </div>
                    <p className={styles.message}>{notification?.message}</p>
                  </div>
                </MenuItem>
              ),
            )}
          </Menu>

          <Menu
            menuButton={
              <MenuButton>
                <div className={styles.menuItem}>
                  {user && (
                    <p>
                      {user?.member?.firstName?.[0] +
                        user?.member?.lastName?.[0]}
                    </p>
                  )}
                </div>
              </MenuButton>
            }
            transition
          >
            <MenuItem onClick={() => dispatch(logoutUser())}>Logout</MenuItem>
          </Menu>
        </div>
      )}

      <NotificationDetailModal
        isOpen={isNotificationModalOpen}
        setIsOpen={setIsNotificationModalOpen}
        notification={selectedNotification}
      />
    </div>
  );
}

export default Header;
